// ── Constantes y estados iniciales — plantillas del plan FREE ────
// Aislado de constants/formConfig.js (clientes a medida): no se comparte nada.

export const ITEMS_CARRETILLA_FREE = [
  "Luces", "Frenos", "Palancas", "Dirección", "Cables batería", "Espejo retrovisor",
  "Estado del asiento", "Estado de las palas", "Nivel agua batería", "Estado de las ruedas",
  "Bocina y marcha atrás", "Cinturón de seguridad", "Hombre muerto pie y seta",
  "Limpieza del habitáculo", "Sistema de elevación y desplazamiento",
];

const initItems = (lista) => { const o = { "TODO CORRECTO": false }; lista.forEach(i => { o[i] = ""; }); return o; };
const initItemsConObs = (lista) => { const o = { "TODO CORRECTO": false }; lista.forEach(i => { o[i] = { value: "", obs: "" }; }); return o; };

export const initCarretillaFree = () => ({
  nombre: "", modelo: "", fecha: new Date().toISOString().slice(0, 10),
  items: initItems(ITEMS_CARRETILLA_FREE),
  observaciones: "", proximaRevision: "", firma: null,
});

export const ITEMS_TRANSPALETA_CRITICOS_FREE = [
  "Ruedas dañadas", "Horquillas rotas o en ángulo", "Dirección/Mandos/Volante dañados",
  "Líquidos - sistema hidráulico (pérdidas)", "Estructura general con deformaciones o grietas",
];
export const ITEMS_TRANSPALETA_ELECTRICA_FREE = [
  "Pantalla dañada", "Batería/cables/bornes dañados", "Paro eléctrico (seta de seguridad)",
  "Claxon no funciona", "Batería por debajo de 70%",
];

export const initTranspaletaFree = () => ({
  nombre: "", modelo: "", tipo: "Manual", fecha: new Date().toISOString().slice(0, 10),
  criticos: initItems(ITEMS_TRANSPALETA_CRITICOS_FREE),
  electrica: initItems(ITEMS_TRANSPALETA_ELECTRICA_FREE),
  usoLimpieza: "",
  observaciones: "", firma: null,
});

// ── Plan Mantenimiento Instalaciones (Diario / Semanal / Mensual) ──
export const MESES_FREE = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

export const ITEMS_MANTENIMIENTO_DIARIO_FREE = ["Limpieza suelos", "Puertas y BIEs sin obstáculos", "General"];
export const initMantenimientoDiarioFree = () => ({
  responsable: "", fecha: new Date().toISOString().slice(0, 10),
  items: initItems(ITEMS_MANTENIMIENTO_DIARIO_FREE),
  firma: null,
});

export const ITEMS_MANTENIMIENTO_SEMANAL_FREE = [
  "Almacén limpio y recogido", "Pallets elevados flejados y seguros", "Zonas de extintores y BIEs despejadas",
  "Estanterías sin daños/cosas a revisar", "Zona de mermas ordenada/limpia/identificada",
  "Carretillas correctas (indicar incidencias no comunicadas en checklist diario)",
];
export const initMantenimientoSemanalFree = () => ({
  responsable: "", periodo: "",
  items: initItems(ITEMS_MANTENIMIENTO_SEMANAL_FREE),
  firma: null,
});

export const CATEGORIAS_MANTENIMIENTO_MENSUAL_FREE = [
  { sec: "1. Gestión de residuos sólidos", items: ["1.1 Los residuos se depositan únicamente en las zonas designadas.", "1.2 Los cubos de basura están en buen estado (íntegros y limpios).", "1.3 La zona de mermas está en correctas condiciones de orden y limpieza."] },
  { sec: "2. Suelos", items: ["2.1 Los suelos están limpios, incluidos rincones y zonas de difícil acceso.", "2.2 El suelo es liso y está sin fisuras, desconchones ni losetas rotas."] },
  { sec: "3. Paredes, columnas, techos", items: ["3.1 Paredes, columnas y techos en buen estado, sin grietas ni orificios.", "3.3 Paredes, columnas y techos con adecuado estado de limpieza."] },
  { sec: "4. Estanterías", items: ["4.1 Las estanterías están en buen estado, sin golpes ni daños estructurales.", "4.2 Los palets en altura están correctamente flejados y colocados de forma segura."] },
  { sec: "5. Maquinaria, equipos y accesorios", items: ["5.1 Los armarios se limpian interior y exteriormente (incluida la parte superior).", "5.3 La maquinaria está en correcto estado de funcionamiento y uso."] },
  { sec: "6. BIEs e incendios — puertas de emergencia", items: ["6.1 Los extintores están correctamente identificados y ubicados.", "6.2 BIEs, extintores y puertas de emergencia están despejados y accesibles."] },
  { sec: "7. Almacenes y zonas de recepción/expedición", items: ["7.1 Los productos están en correcto estado y almacenados aislados del suelo.", "7.2 No hay productos caducados o deteriorados sin identificar.", "7.3 Todos los productos están correctamente identificados, incluidos no conformes."] },
  { sec: "8. Climatización e iluminación", items: ["8.1 Los tubos fluorescentes y bombillas están íntegros.", "8.2 Los equipos de climatización están en correcto estado de limpieza y mantenimiento."] },
  { sec: "9. Vestuarios, servicios, lavamanos", items: ["9.1 Los lavamanos disponen de agua caliente/fría, jabón y papel secamanos.", "9.2 No hay ropa, calzado u objetos en el suelo o encima de taquillas.", "9.3 Aseos, vestuarios y taquillas en correcto estado de mantenimiento y limpieza."] },
  { sec: "10. Otros", items: ["10.1 Los palets de madera están en buen estado, sin roturas ni astillas y separados de la pared.", "10.2 Número de palets retirados por mal estado."] },
  { sec: "11. Desinsectación, desratización", items: ["11.1 Las trampas de control de plagas están identificadas y correctamente ubicadas."] },
  { sec: "12. Limpieza y desinfección", items: ["12.1 Los productos de limpieza son los establecidos en el Plan de Limpieza y la documentación está disponible.", "12.2 Se cumplimentan correctamente los registros de limpieza.", "12.4 No se observan zonas, maquinaria o utensilios con suciedad significativa."] },
  { sec: "13. Imagen y hábitos de manipuladores", items: ["13.1 El personal mantiene condiciones higiénicas adecuadas en uniforme e imagen.", "13.3 Se cumple la prohibición de fumar en las instalaciones."] },
  { sec: "14. Mantenimiento y documentación", items: ["14.2 Se realizan los check list de revisión establecidos.", "14.3 Se realiza la homologación de proveedores conforme al procedimiento establecido."] },
];
export const initMantenimientoMensualFree = () => {
  const n = new Date();
  const categorias = {};
  CATEGORIAS_MANTENIMIENTO_MENSUAL_FREE.forEach(c => { categorias[c.sec] = initItemsConObs(c.items); });
  return { responsable: "", mes: MESES_FREE[n.getMonth()], anio: String(n.getFullYear()), categorias, observaciones: "", firma: null };
};

// ── Flota (checklist completo de vehículo) ────────────────────────
export const DOCS_FLOTA_FREE = ["Ficha técnica", "Póliza seguro", "Permiso circulación", "Doc. Inspección Tacógrafo"];
export const ITEMS_FLOTA_ELEMENTOS_FREE = ["Extintor", "Papel tacógrafo", "Botiquín sanitario", "Llave puerta elevadora"];
export const ITEMS_FLOTA_HERRAMIENTAS_FREE = ["Retractiladora", "Cutter/navaja", "Transpaleta manual", "EPIs (guantes, chaleco)"];
export const ITEMS_FLOTA_ESTADO_FREE = ["Luces", "Baliza", "Separadores", "Limpieza interior/exterior", "Neumáticos: dirección/tracción"];

const initDocs = (lista) => { const o = {}; lista.forEach(i => { o[i] = ""; }); return o; };

export const initFlotaFree = () => ({
  nombre: "", matricula: "", fecha: new Date().toISOString().slice(0, 10),
  documentacion: initDocs(DOCS_FLOTA_FREE),
  elementosObligatorios: initItems(ITEMS_FLOTA_ELEMENTOS_FREE),
  herramientas: initItems(ITEMS_FLOTA_HERRAMIENTAS_FREE),
  estadoGeneral: initItems(ITEMS_FLOTA_ESTADO_FREE),
  observaciones: "", firma: null,
});

// ── Vehículo Exprés (checklist rápido diario) ─────────────────────
export const ITEMS_VEHICULO_EXPRES_FREE = [
  "Luces", "Frenos", "Neumáticos", "Niveles (aceite/agua/combustible)",
  "Documentación a bordo (ficha técnica + seguro)", "Extintor presente",
];

export const initVehiculoExpresFree = () => ({
  nombre: "", matricula: "", fecha: new Date().toISOString().slice(0, 10),
  items: initItems(ITEMS_VEHICULO_EXPRES_FREE),
  observaciones: "", firma: null,
});
